<div class="d-flex align-items-center">
    <input class="form-check-input checkbox defaultheight" type="checkbox" [id]="roleItem" [checked]="userInRole" (click)="updateRoles($event)" [disabled]="!righsEditable || roleItem === 'Customer'">
    <label class="form-check-label" for="flexCheckDefault" translate>Roles.{{roleItem}}</label>
</div>